import { render, staticRenderFns } from "./DependentList.vue?vue&type=template&id=98d75a6c&scoped=true"
import script from "./DependentList.vue?vue&type=script&lang=js"
export * from "./DependentList.vue?vue&type=script&lang=js"
import style0 from "./DependentList.vue?vue&type=style&index=0&id=98d75a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d75a6c",
  null
  
)

export default component.exports